module.exports = __webpack_public_path__ + "1b8788e49e12fe317f53e9b590056580.svg";